export default {
    install: function(Vue, options) {
        Vue.prototype.$okaTool = this;
    },
    checkOS: function(){ //檢查 OS
        let _userAgent = window.navigator.userAgent,
            _platform = window.navigator.platform,
            _os = '';

        let $macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            $windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            $iosPlatforms = ['iPhone', 'iPad', 'iPod']
  
        if( $macosPlatforms.includes(_platform) ) {
            _os = 'Mac OS';
        }else if( $iosPlatforms.includes(_platform) ) {
            _os = 'iOS';
        }else if( $windowsPlatforms.includes(_platform) ) {
            _os = 'Windows';
        }else if( /Android/.test(_userAgent) ) {
            _os = 'Android';
        }else if( !_os && /Linux/.test(_platform) ) {
            _os = 'Linux';
        }
  
        return _os;
    },
    checkMobile: function(){ //檢查是不是手機
        let $mobilePlatforms = ['iOS', 'Android'],
            _os = this.checkOS();

        return $mobilePlatforms.includes(_os)
    },
    getUUID: function(){ //取得 UUID
        let d = Date.now();

        if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
            d += performance.now(); //use high-precision timer if available
        }
        
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
    },
    doubleCount: function(num){ //補兩位數

        if(typeof num === 'number') {

            if( num < 10 ) {
                return '0'+ num;
            }else {
                return num;
            }
        }else if(typeof num === 'string'){

            if( num.length === 0 ) {
                return '00';
            }else if( num.length === 1 ){
                return '0'+ num;
            }else {
                return num;
            }
        }else {
            console.log('$doubleCount: 參數必須為數字或字串, 原始數值為: '+ num);
            
            return '00';
        }
    },
    judgeColor: function(color, type){
        let _condition = 255 * 3 / 2,
            _all = addAll(color); //平均色

        function addAll(color){
            let _all = 0;

            color.forEach(value => {
                _all += value;
            });

            return _all;
        }

        if( type === undefined || (type === 'light' && _all > _condition) || (type === 'deep' && _all < _condition) ) {
            return true;
        }else {
            return false;
        }
    },
    mixColor: function (color1, color2, weight) { //顏色合併，接受兩個 hex 顏色與一個數字權重
        let $color1 = this.hexToRgb(color1),
            $color2 = this.hexToRgb(color2),
            _weight = weight;

        if( weight === undefined ) {
            _weight = 50;
        }

        let $newColor = [];

        for( let i = 0; i < 3; i++ ) { //rgb
            let _num = Math.floor($color2[i] + ($color1[i] - $color2[i]) * (_weight / 100));
            $newColor.push(_num)
        }

        return this.rgbToHex($newColor);
    },
    lightenDarkenColor: function(p,c0,c1,l) {
        let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
        if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
        if(!this.pSBCr)this.pSBCr=(d)=>{
            let n=d.length,x={};
            if(n>9){
                [r,g,b,a]=d=d.split(","),n=d.length;
                if(n<3||n>4)return null;
                x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
            }else{
                if(n==8||n==6||n<4)return null;
                if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
                d=i(d.slice(1),16);
                if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
                else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
            }return x};
        h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
        if(!f||!t)return null;
        if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
        else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
        a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
        if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
        else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
    },
    rgbToHex: function ($colors) { //轉換成 hex color
        let _hex = '#';

        function componentToHex(color) {
            var hex = color.toString(16);
            return hex.length == 1 ? '0' + hex : hex;
        }

        $colors.forEach(color => {
            _hex += componentToHex(color);
        });

        return _hex;
    },
    hexToRgb: function(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

        return result ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16)
        ]: null;
    },
    randomColor: function(type){ //取得隨機顏色
        let $colors = getColor();

        function getColor(){ //生成 rgb 顏色
            let $color = [0, 0, 0]; //r, g, b

            $color.forEach((value, index) => {
                let _newColor = Math.floor(Math.random() * 255);

                $color[index] = _newColor;
            });

            return $color;
        }

        if( type ) { //light, deep or undefined

            while(!this.judgeColor($colors, type)) {
                $colors = getColor();
            }
        }

        return this.rgbToHex($colors);
    },
    colorList: ['#3D5AFE','#D32F2F','#81C784','#311B92','#9E9D24','#9C27B0','#F9A825','#FF80AB','#00838F','#FF6E40','#2E7D32','#F50057','#6D4C41','#455A64'],
    materialColors: ['#FFEBEE', '#FFCDD2', '#EF9A9A', '#E57373', '#EF5350', '#F44336', '#E53935', '#D32F2F', '#C62828', '#B71C1C', '#FF8A80', '#FF5252', '#FF1744', '#D50000', '#FCE4EC', '#F8BBD0', '#F48FB1', '#F06292', '#EC407A', '#E91E63', '#D81B60', '#C2185B', '#AD1457', '#880E4F', '#FF80AB', '#FF4081', '#F50057', '#C51162', '#F3E5F5', '#E1BEE7', '#CE93D8', '#BA68C8', '#AB47BC', '#9C27B0', '#8E24AA', '#7B1FA2', '#6A1B9A', '#4A148C', '#EA80FC', '#E040FB', '#D500F9', '#AA00FF', '#EDE7F6', '#D1C4E9', '#B39DDB', '#9575CD', '#7E57C2', '#673AB7', '#5E35B1', '#512DA8', '#4527A0', '#311B92', '#B388FF', '#7C4DFF', '#651FFF', '#6200EA', '#E8EAF6', '#C5CAE9', '#9FA8DA', '#7986CB', '#5C6BC0', '#3F51B5', '#3949AB', '#303F9F', '#283593', '#1A237E', '#8C9EFF', '#536DFE', '#3D5AFE', '#304FFE', '#E3F2FD', '#BBDEFB', '#90CAF9', '#64B5F6', '#42A5F5', '#2196F3', '#1E88E5', '#1976D2', '#1565C0', '#0D47A1', '#82B1FF', '#448AFF', '#2979FF', '#2962FF', '#E1F5FE', '#B3E5FC', '#81D4FA', '#4FC3F7', '#29B6F6', '#03A9F4', '#039BE5', '#0288D1', '#0277BD', '#01579B', '#80D8FF', '#40C4FF', '#00B0FF', '#0091EA', '#E0F7FA', '#B2EBF2', '#80DEEA', '#4DD0E1', '#26C6DA', '#00BCD4', '#00ACC1', '#0097A7', '#00838F', '#006064', '#84FFFF', '#18FFFF', '#00E5FF', '#00B8D4', '#E0F2F1', '#B2DFDB', '#80CBC4', '#4DB6AC', '#26A69A', '#009688', '#00897B', '#00796B', '#00695C', '#004D40', '#A7FFEB', '#64FFDA', '#1DE9B6', '#00BFA5', '#E8F5E9', '#C8E6C9', '#A5D6A7', '#81C784', '#66BB6A', '#4CAF50', '#43A047', '#388E3C', '#2E7D32', '#1B5E20', '#B9F6CA', '#69F0AE', '#00E676', '#00C853', '#F1F8E9', '#DCEDC8', '#C5E1A5', '#AED581', '#9CCC65', '#8BC34A', '#7CB342', '#689F38', '#558B2F', '#33691E', '#CCFF90', '#B2FF59', '#76FF03', '#64DD17', '#F9FBE7', '#F0F4C3', '#E6EE9C', '#DCE775', '#D4E157', '#CDDC39', '#C0CA33', '#AFB42B', '#9E9D24', '#827717', '#F4FF81', '#EEFF41', '#C6FF00', '#AEEA00', '#FFFDE7', '#FFF9C4', '#FFF59D', '#FFF176', '#FFEE58', '#FFEB3B', '#FDD835', '#FBC02D', '#F9A825', '#F57F17', '#FFFF8D', '#FFFF00', '#FFEA00', '#FFD600', '#FFF8E1', '#FFECB3', '#FFE082', '#FFD54F', '#FFCA28', '#FFC107', '#FFB300', '#FFA000', '#FF8F00', '#FF6F00', '#FFE57F', '#FFD740', '#FFC400', '#FFAB00', '#FFF3E0', '#FFE0B2', '#FFCC80', '#FFB74D', '#FFA726', '#FF9800', '#FB8C00', '#F57C00', '#EF6C00', '#E65100', '#FFD180', '#FFAB40', '#FF9100', '#FF6D00', '#FBE9E7', '#FFCCBC', '#FFAB91', '#FF8A65', '#FF7043', '#FF5722', '#F4511E', '#E64A19', '#D84315', '#BF360C', '#FF9E80', '#FF6E40', '#FF3D00', '#DD2C00', '#EFEBE9', '#D7CCC8', '#BCAAA4', '#A1887F', '#8D6E63', '#795548', '#6D4C41', '#5D4037', '#4E342E', '#3E2723', '#FAFAFA', '#F5F5F5', '#EEEEEE', '#E0E0E0', '#BDBDBD', '#9E9E9E', '#757575', '#616161', '#424242', '#212121', '#ECEFF1', '#CFD8DC', '#B0BEC5', '#90A4AE', '#78909C', '#607D8B', '#546E7A', '#455A64', '#37474F', '#263238'],
    getMaterialColor: function(type){ //取得既定顏色
        let $colorArray = this.materialColors,
            _length = $colorArray.length,
            $hexToRgb = this.hexToRgb;

        function getColor(){ //生成 hex 顏色
            let $randomColor = $colorArray[Math.floor(Math.random() * _length)];

            return $hexToRgb($randomColor);
        }

        let $colors = getColor();

        if( type ) { //light, deep or undefined

            while(!this.judgeColor($colors, type)) {
                $colors = getColor();
            }
        }

        return this.rgbToHex($colors);
    },
    extend: function(opt){ //合併、補上預設值，可以補特殊前輟
        let $target = opt.target || {},
            $ref = opt.ref || {},
            _key = opt.key,
            _prefix = opt.prefix, //前輟
            _copy = opt.copy, //true 返回 copy 擴展後的結果，false 則直接擴展本身
            _hard = opt.hard; //是否要硬覆蓋

        if( $target === $ref ) {
            return $target;
        }

        let $obj = null;

        if (typeof $target === 'object') {

            if( _copy !== false ) {
                $obj = this.copy($target, true);
            }else {
                $obj = $target;
            }
        }

        if( _key ) { //如果要指定在某個 key 下

            if( $obj[_key] === undefined ) {
                $obj[_key] = {};
            }

            $obj = $obj[_key];
        }

        for (let key in $ref) {
            let _key = key;

            if( _prefix && typeof _prefix === 'string' ) { //如果有傳入 String 就在 key 前面補前輟字串
                _key = _prefix + _key;
            }

            if( _hard === true || $obj[_key] === undefined ) {
                $obj[_key] = $ref[key];
            }
        }

        return $obj;
    },
    copy: function(target, needUndefined){ //copy object

        if (typeof target === 'object') {
            let $result = {};

            if( needUndefined ) { //如果需要那些 undefind 屬性

                for( let _key in target ) {
                    $result[_key] = target[_key];
                }
            }else {
                $result = JSON.parse(JSON.stringify(target));
            }

            return $result;
        } else {
            return target;
        }
    },
    hasRepeat: function(arr){

        if( Array.isArray(arr) ) {
            let $hash = {};

            for(let _key in arr) {

                if( $hash[arr[_key]] ) {
                    return true;
                }

                $hash[arr[_key]] = true;
            }

            return false;
        }else {
            console.error('not an array.');
        }
    },
    splitJsonNetTime: function(string){
        return string.replace(/T\d\d|:\d\d/g, '');
    },
    getLastDate: function(year, month){ //實際 month 非 javascript month
        return new Date(year, month, 0).getDate();
    },
    timeInterval: function(opt){ //計算時間(到日)
        let _unit = opt.unit || 'month', // year, y, month, m, date, d, time, t
            _away = opt.away || 'after', //before, <, after , >
            _time = opt.time, //2019-01-01
            _int = opt.int || 0;

        let $time = new Date(_time);

        let $baseTime = {},
            $resultTime = {};

        let _default = null;

        _default = this.textFormatter(null);

        let $result = {
                y: _default,
                ym: _default,
                ymd: _default,
                ymdh: _default,
                ymdhm: _default,
                t: _default
            }

        if( !this.isValidDate($time) || _time === null ) {
            return $result;
        }

        $resultTime.year =  $baseTime.year = $time.getFullYear();
        $resultTime.month = $baseTime.month = $time.getMonth() + 1;
        $resultTime.date = $baseTime.date = $time.getDate();
        $resultTime.hours = $baseTime.hours = $time.getHours();
        $resultTime.minutes = $baseTime.minutes = $time.getMinutes();

        if( _unit === 'year' || _unit === 'y' ) {

            if( _away === 'after' || _away === '>' ) {
                $resultTime.year = $baseTime.year + _int;
            }else if( _away === 'before' || _away === '<' ) {
                $resultTime.year = $baseTime.year - _int;
            }
        }else if( _unit === 'month' || _unit === 'm' ){

            if( _away === 'after' || _away === '>' ) {
                let _computedMonth = $baseTime.month + _int;

                if( _computedMonth > 12 ) {
                    $resultTime.year += Math.floor(_int / 12);
                    $resultTime.month += ( _int % 12 );

                    if( $resultTime.month > 12 ) {
                        $resultTime.year += 1;
                        $resultTime.month -= 12;
                    }
                }else {
                    $resultTime.month = _computedMonth;
                }
            }else if( _away === 'before' || _away === '<' ) {
                let _computedMonth = $baseTime.month - _int; //-30

                if( _computedMonth < 1 ) {
                    $resultTime.year -= Math.floor(_int / 12); //2
                    $resultTime.month -= ( _int % 12 ); //6

                    if( $resultTime.month < 1 ) {
                        $resultTime.year -= 1;
                        $resultTime.month += 12;
                    }
                }else {
                    $resultTime.month = _computedMonth;
                }
            }
        }else if( _unit === 'date' || _unit === 'd' ) {
            let _computedInt = _int * 24 * 60 * 60 * 1000,
                _computedTime = new Date($time.toLocaleDateString()).getTime();

            let _computedResult = null;

            if( _away === 'after' || _away === '>' ) {
                _computedResult = _computedTime + _computedInt;
            }else if( _away === 'before' || _away === '<' ) {
                _computedResult = _computedTime - _computedInt;
            }

            let $result = new Date(_computedResult);

            $resultTime.year = $result.getFullYear();
            $resultTime.month = $result.getMonth() + 1;
            $resultTime.date = $result.getDate();
        }else if( _unit === 'time' || _unit === 't' ) {
            let _computedInt = _int, //毫秒數
                _computedTime = new Date($time).getTime();

            let _computedResult = null;

            if( _away === 'after' || _away === '>' ) {
                _computedResult = _computedTime + _computedInt;
            }else if( _away === 'before' || _away === '<' ) {
                _computedResult = _computedTime - _computedInt;
            }

            let $result = new Date(_computedResult);

            $resultTime.year = $result.getFullYear();
            $resultTime.month = $result.getMonth() + 1;
            $resultTime.date = $result.getDate();
            $resultTime.hours = $result.getHours();
            $resultTime.minutes = $result.getMinutes();
        }

        let _lastDate = this.getLastDate($resultTime.year, $resultTime.month);

        if( _lastDate < $resultTime.date ) {
            $resultTime.date = _lastDate;
        }

        $result.y = $resultTime.year;
        $result.m = $resultTime.month;
        $result.d = $resultTime.date;
        $result.ym = $result.y +'-'+ this.doubleCount($resultTime.month);
        $result.ymd = $result.ym +'-'+ this.doubleCount($resultTime.date);
        $result.ymdh = $result.ymd +' '+ this.doubleCount($resultTime.hours);
        $result.ymdhm = $result.ymdh +':'+ this.doubleCount($resultTime.minutes);
        $result.t = this.doubleCount($resultTime.hours) +':'+ this.doubleCount($resultTime.minutes);

        return $result;
    },
    timeValidate: function(endTime, startTime, away) {
        let $startTime = new Date(startTime.toString()),
            $endTime = new Date(endTime.toString());

        let _away = away || '>=',
            _result = false;

        if( _away === 'after' || _away === '>' ) {

            if( $endTime > $startTime ){
                return true;
            }
        }else if( _away === 'equalAfter' || _away === '>=' ) {

            if( $endTime >= $startTime ){
                return true;
            }
        }else if( _away === 'before' || _away === '<' ) {

            if( $endTime < $startTime ){
                return true;
            }
        }else if( _away === 'equalBefore' || _away === '<=' ) {

            if( $endTime <= $startTime ){
                return true;
            }
        }
        
        return _result;
    },
    isValidDate: function(date) {
        return date instanceof Date && !isNaN(date);
    },
    isDate: function(string) {
        let _result = false;

        if( typeof string !== 'string' ) {
            return _result;
        }

        let $rule = new RegExp(/(^\d{4}[\/|\-]\d{1,2}[\/|\-]\d{1,2}$)|(^\d{4}[\/|\-]\d{1,2}$)/),
            $match = string.match($rule);

        if( $match ) {
            _result = true;
        }

        return _result;
    },
    isNumber: function(string) {
        let _result = false;

        if( typeof string !== 'string' ) {
            return _result;
        }

        let _string = string.replace(/\,/g, ''),
            $rule = new RegExp(/(^\d+$)|(^\d+\.\d+$)|(^\d+\%$)|(^\d+\.\d+\%$)/),
            $match = _string.match($rule);

        if( $match && $match[0] && $match[0].length === _string.length ) {
            _result = true;
        }

        return _result;
    },
    dateToStringFormat: function(time) {
        let $time = new Date(time);

        if( !this.isValidDate($time) ) {
            $time = new Date();
        }

        let _year = $time.getFullYear(),
            _month = $time.getMonth() + 1,
            _date = $time.getDate();

        let _ym = _year +'-'+ this.doubleCount(_month),
            _ymd = _ym +'-'+ this.doubleCount(_date);

        return {
            year: _year,
            month: _month,
            date: _date,
            ym: _ym,
            ymd: _ymd
        }
    },
    numberToDataFormat: function(num) { //數字 * 1000 轉時間物件
        let $result = null

        if( typeof num === 'string' ) {

            if( parseFloat(num) == num ) {
                num = parseFloat(num);
            }
        }

        if( typeof num === 'number' ) {
            $result = this.timeInterval({
                time: new Date(num * 1000),
                unit: 'date'
            })
        }else {
            $result = this.timeInterval({
                time: new Date(),
                unit: 'date'
            })
        }

        return $result;
    },
    numberToStringFormat: function(num, digits) { //要處理的數字, 取幾位數
        let _digits = digits;

        if( typeof _digits !== 'number' ) {
            _digits = 10;
        }

        if( typeof num === 'string' ) {

            if( parseFloat(num) == num ) {
                num = parseFloat(num);
            }else {
                return num;
            }
        }

        if( typeof num === 'number' ) {
            let _label = num + '',
                $label = _label.split('.'), //陣列，[0] 是數字，[1] 是小數
                _int = $label[0],
                _float = '';

            if( $label.length > 1 && $label[1].length > 0 && _digits > 0 ) {
                let _decimal = '0.'+ $label[1].substr(0, _digits);

                _decimal = parseFloat(_decimal).toString();

                _decimal = _decimal.replace('0.', '');

                if( _decimal !== '0' ) {
                    _float = '.'+ _decimal;
                }
            }

            let $rgx = /(\d+)(\d{3})/;

            while ( $rgx.test(_int) ) {
                _int = _int.replace($rgx, '$1' + ',' + '$2');
            }

            let _result = _int + _float;

            return _result;
        }else {
            return num;
        }
    },
    stringFormatToNumber: function(str) {

        if( typeof str === 'string' ) {
            return parseFloat(str.replace(/\,/g, ''), 10);
        }else {
            return str;
        }
    },
    stringFormatToDate: function(str) { //只考慮西元年

        if( typeof str === 'string' ) {
            let _str = str.replace(/\/|\-/g, ''),
                _length = _str.length;

            if( _length === 6 ) {
                return str.replace(/(\d{4})(\d{2})/, '$1-$2');
            }else if( _length === 8 ) {
                return str.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
            }else {
                return str;
            }

        }else {
            return str;
        }
    },
    htmlFilter: function(str){

        if( typeof str === 'string' ) {
            return str.replace(/<[^>]*>?/gm, '');
        }else {
            return str;
        }
    },
    isEmptyObj: function(obj) {
        return JSON.stringify(obj) === '{}';
    },
    convertToString: function(something){

        if( something === null ) {
            return 'null';
        }else if( something === undefined ){
            return 'undefined';
        }else if( typeof something === 'boolean' ){
            return something.toString();
        }else if( isNaN(something) ) {
            return 'NaN';
        }else {
            return something;
        }
    },
    textFormatter: function(text){

        if( text === null ) {
            return '無';
        }else if( text === undefined ) {
            return '';
        }else if( text === false ) {
            return '否';
        }else if( text === true ) {
            return '是';
        }else {
            return text;
        }
    },
    getFileName: function(str){
        let _result = '';

        if( typeof str === 'string' ) {
            _result = str.slice((str.lastIndexOf('/') - 1 >>> 0) + 2);
        }

        return _result;
    },
    getExtension: function(str){
        let _result = '';

        if( typeof str === 'string' ) {
            _result = str.slice((str.lastIndexOf('.') - 1 >>> 0) + 2);
        }

        return _result;
    },
    slide: function(node, num, speed){ //like jquery slide
        let $timer = null,
            _currentHeight = parseInt(node.clientHeight),  // Current height
            _initTime = (new Date()).getTime(); //start time

        let _disp = num - _currentHeight;

        $timer = setInterval(() => {
            let _instance = (new Date()).getTime() - _initTime; //animating time

            if(_instance <= speed ) {
                let _pos = _currentHeight + Math.floor(_disp * _instance / speed);

                node.style.height = _pos + 'px';
            }else {
                node.style.height = num + 'px';
                
                clearInterval($timer);
            }
        }, 1);
    }
}
